export const OUTCOME_TYPE = {
  BADGE: 'badge',
  /** 'reward' type is going to be deprecated in favor of Reward::Campaign */
  REWARD: 'reward',
  /** 'points' type is going to be deprecated in favor of StoredValue::Campaign */
  POINT: 'points',
  PRIZE_SET: 'prize_set',
  RANDOMIZED_OUTCOME_SET: 'randomized_outcome_set',
  ADD_PRIZE_SET: 'add_prize_set',
  PRIZE_SET_REWARD: 'prize_set_reward',
  PRIZE_SET_POINT: 'prize_set_points',
  CUSTOM: 'custom',
  REWARD_CAMPAIGN: 'Reward::Campaign',
  STORED_VALUE_CAMPAIGN: 'StoredValue::Campaign',
  GAME_TRY: 'campaign'
} as const;

export const OUTCOME_TITLE = {
  [OUTCOME_TYPE.REWARD]: 'Reward',
  [OUTCOME_TYPE.PRIZE_SET]: 'Prize set',
  [OUTCOME_TYPE.POINT]: 'Points',
  [OUTCOME_TYPE.BADGE]: 'Badge',
  [OUTCOME_TYPE.RANDOMIZED_OUTCOME_SET]: 'Random prize set',
  [OUTCOME_TYPE.CUSTOM]: 'No Prize',
  [OUTCOME_TYPE.GAME_TRY]: 'Game try'
};

export const OUTCOME_CHOICES_CONFIG = {
  FIXED_PRIZE: 'fixed_prize',
  CHOOSE_PRIZE: 'choose_prize'
};

export const OUTCOME_CHOICES_CONFIG_TITLE = {
  [OUTCOME_CHOICES_CONFIG.FIXED_PRIZE]: 'Customers get a fixed prize',
  [OUTCOME_CHOICES_CONFIG.CHOOSE_PRIZE]: 'Customers choose their preferred prize'
};

export const CHOOSE_YOUR_REWARD_CAMPAIGN_TYPES = [
  'instant_outcome',
  'progress',
  'game',
  'quiz',
  'survey',
  'quest'
];

// Both outcome editors (PrizeSet and the PRIZE_SETS-off GameOutcomes path) must
// apply the same rule, or the toggle leaks onto campaign types with no CYR path.
// bubble_pop is excluded on every campaign type.
export const isChooseYourRewardSupported = (campaignType: string, gameType?: string | null) =>
  CHOOSE_YOUR_REWARD_CAMPAIGN_TYPES.includes(campaignType) && gameType !== 'bubble_pop';
